
const routes = [{
  path: '/:tenant/setup',
  meta: {
    noAuthentification: true,
  },
  component: () => import('layouts/SetupLayout.vue'),
  children: [
    { name: 'Setup', path: '', component: () => import('pages/SetupPage.vue') },
  ]
},
{
  path: '/:tenant/check/:id',
  meta: {
    basicAuthentification: true,
  },
  component: () => import('layouts/PublicLayout.vue'),
  children: [
    {
      name: 'Incident',
      path: '', component: () => import('pages/IncidentPage.vue'),
      props: { sender: 'whistleblower' }
    },
  ]
},
{
  path: '/:tenant/channel/:channel/',
  meta: {
    noAuthentification: true,
  },
  component: () => import('layouts/PublicLayout.vue'),
  children: [
    { name: 'Start_Channel', path: '', component: () => import('pages/StartPage.vue') },
    {
      meta: {
        noAuthentification: true,
      }, name: 'Check_Channel', path: 'check', component: () => import('pages/CheckPage.vue'), props: { sender: 'whistleblower' }
    },
    { name: 'New_Channel', path: 'new', component: () => import('pages/NewPage.vue'), props: { sender: 'whistleblower' } },
  ]
},
{
  path: '/:tenant/',
  meta: {
    noAuthentification: true,
  },
  component: () => import('layouts/PublicLayout.vue'),
  children: [
    { name: 'Start', path: '', component: () => import('pages/StartPage.vue') },
    {
      meta: {
        noAuthentification: true,
      }, name: 'Check', path: 'check', component: () => import('pages/CheckPage.vue'), props: { sender: 'whistleblower' }
    },
    { name: 'New', path: 'new', component: () => import('pages/NewPage.vue'), props: { sender: 'whistleblower' } },

    { name: 'Imprint', path: 'imprint', component: () => import('pages/VaDokLinkPage.vue'), props: { type: 'imprint' } },
    { name: 'DataPrivacy', path: 'dataprivacy', component: () => import('pages/VaDokLinkPage.vue'), props: { type: 'dataprivacy' } },
    { name: 'Policy', path: 'policy', component: () => import('pages/VaDokLinkPage.vue'), props: { type: 'policy' } },
  ]
},
{
  path: '/:tenant/tenants/',
  component: () => import('layouts/MainLayout.vue'),
  children: [
    { path: '', component: () => import('pages/TenantsOverview.vue') },
  ]
},
{
  path: '/:partner/tenants/',
  component: () => import('layouts/MainLayout.vue'),
  children: [
    { path: ':tenant/incidents', component: () => import('pages/ListPage.vue') },

    {
      path: ':tenant/dashboard', component: () => import('pages/DashboardPage.vue'),
    },
    {
      path: ':tenant/incidents/:id', component: () => import('pages/IncidentPage.vue'),
      props: { sender: 'user' }
    },
  ]
},
{
  path: '/:tenant/incidents/',
  component: () => import('layouts/MainLayout.vue'),
  children: [
    { path: '', component: () => import('pages/ListPage.vue') },
    {
      path: ':id', component: () => import('pages/IncidentPage.vue'),
      props: { sender: 'user' }
    },
  ]
},
{
  path: '/:tenant/login/',
  meta: {
    noAuthentification: true,
  },
  component: () => import('layouts/PublicLayout.vue'),
  children: [
    { name: 'Login', path: '', component: () => import('pages/AuthPage.vue') },
  ]
},
{
  path: '/:tenant/users/:userId',
  component: () => import('layouts/MainLayout.vue'),
  children: [
    { path: '', component: () => import('pages/UserPage.vue') },
  ]
},
{
  path: '/:tenant/users/:userId/resetpassword',
  meta: {
    noAuthentification: true,
  },
  component: () => import('layouts/PublicLayout.vue'),
  children: [
    { path: '', component: () => import('pages/ResetPassword.vue') },
  ]
},
{
  path: '/:tenant/dashboard/',
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '', component: () => import('pages/DashboardPage.vue'),
    },]
},
{
  path: '/:tenant/settings/',
  component: () => import('layouts/MainLayout.vue'),
  name: 'Settings',
  children: [
    {
      path: '', name: 'Settings', component: () => import('pages/SettingsPage.vue'),
    },]
},
// Always leave this as last one,
// but you can also remove it
{
  path: '/:catchAll(.*)*',
  name: 'Error',
  meta: {
    noAuthentification: true,
  },
  component: () => import('pages/ErrorNotFound.vue')
}
]

export default routes
